import React, { useState, useEffect } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { Container } from 'react-bootstrap';
import { defaultCenterMap, Localidad, mapStyle } from '../../../../service/types/types';
import { LocalidadesService } from '../../../../service/localidades.service';
import LocalidadTable from './tables/localidad.table';
import { FeedbackModal } from '../../../common/feedback.modal';

export default function LocalidadesMapTable() {
  
  const [center, setCenter] = useState(defaultCenterMap);
  const [localidades, setLocalidades] = useState<Localidad[]>([]);
  const [reloadFlag, setReloadFlag] = useState(false);
  //modal
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<"success" | "error">("success");
  const [modalMessage, setModalMessage] = useState("");
  

  useEffect(() => {
    const fetchLocalidades = async () => {
      try {
        const data = await LocalidadesService.findAll();
        setLocalidades(data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchLocalidades();
  }, [reloadFlag]);
  const onSave = (isOk: boolean) => {
    if (isOk) {
      setModalType("success")
      setModalMessage("Predio Guardado Correctamente")
      setReloadFlag((prev) => !prev); // 👈 alterna el flag y fuerza el useEffect
    } else {
      setModalType("error")
      setModalMessage("Error Guardado Predio")
    }
    setShowModal(true);
  };


  const handleEdit = (id: string) => {
    alert(`Editar localidad con id: ${id}`);
  };

  const handleGo = (lat: number, lng: number) => { 
    setCenter({ lat, lng }); // 👈 actualiza el centro del mapa
  };

  return (
    <Container fluid className="p-0">
      <FeedbackModal
        show={showModal}
        onHide={() => setShowModal(false)}
        type={modalType}
        message={modalMessage}
        autoClose={true}   // 👈 se cierra solo en 3s
        duration={3000}
      />
      <GoogleMap mapContainerStyle={mapStyle} center={center} zoom={12}>
        {localidades.map((localidad) => (
          <Marker key={localidad.id} position={{ 
            lat: localidad.location.coordinates[1], 
            lng: localidad.location.coordinates[0] 
          }} />
        ))}
      </GoogleMap>
      <br/>
      {/* Mitad inferior: Tabla */}
      <div style={{ height: '50vh', overflowY: 'auto', padding: '1rem' }}>
        <LocalidadTable
          localidades={localidades}
          onSave={onSave}
          onGo={handleGo}
        />
      </div>
    </Container>
  );
}